import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-breadcrumbs',
  styleUrl: 'breadcrumbs.css',
  shadow: true,
})
export class IntroText {
  @Prop() currentpagename: string;
  @Prop() homelinkurl: string;

  render() {
    return (
      <nav aria-label="Page Breadcrumbs" class="breadcrumbs">
        <div class="breadcrumb-links">
          <a href={this.homelinkurl} class="home-crumb">Home</a>
          <slot />
          <a class="current-page">{this.currentpagename}</a>
        </div>
      </nav>
    );
  }
}
